import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import axios from 'axios';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    userEmail: null,
    token: null,
    auth: null,
  },
  getters: {
    userEmail: state => state.userEmail,
    token: state => state.token,
    auth: state => state.auth,
    isAuthenticated: state => !!state.token, // 토큰이 있는지 확인
  },
  actions: {
    login({ commit }, { email, token, auth }) {
      commit('setUser', { email, token, auth });
    },
    logout({ commit }) {
      commit('clearUser');
    },
    async fetchUserData({ commit }) {
      try {
        const response = await axios.get('/api/user-info');
        const { email, token, auth } = response.data;
        commit('setUser', { email, token, auth });
      } catch (error) {
        console.error('Failed to fetch user data:', error);
      }
    },
  },
  mutations: {
    setUser(state, { email, token, auth }) {
      state.userEmail = email;
      state.token = token;
      state.auth = auth;
    },
    clearUser(state) {
      state.userEmail = null;
      state.token = null;
      state.auth = null;
    },
  },
  plugins: [
    createPersistedState({
      paths: ['userEmail', 'token', 'auth'], // 저장할 상태 설정
    }),
  ],
});
